import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import Paper from "@material-ui/core/Paper";

// Сколько подсказка видна после наведения на строку.
export const ROW_HINT_MS = 2500;

// Подсказка у курсора при наведении на строку таблицы: видна пару секунд и прячется, при новом
// наведении появляется снова. Управляется через ref (show / hide), чтобы сама таблица не
// перерисовывалась от каждого движения мыши.
const RowHint = forwardRef(function RowHint(props, ref) {
  const [hint, setHint] = useState(null);
  const timer = useRef(null);

  const hide = () => {
    clearTimeout(timer.current);
    setHint(null);
  };

  useImperativeHandle(ref, () => ({
    show: (text, x, y) => {
      clearTimeout(timer.current);
      setHint({ text, x, y });
      timer.current = setTimeout(() => setHint(null), ROW_HINT_MS);
    },
    hide,
  }));

  useEffect(() => () => clearTimeout(timer.current), []);

  if (!hint) return null;
  return (
    <Paper
      role="tooltip"
      elevation={3}
      style={{
        position: "fixed",
        left: hint.x + 12,
        top: hint.y + 12,
        zIndex: 1500,
        padding: "6px 10px",
        fontSize: 13,
        pointerEvents: "none",
        maxWidth: 320,
      }}
    >
      {hint.text}
    </Paper>
  );
});

export default RowHint;
